
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_phaseAB",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.phaseAB')
        },
        value() {
            return this.unitLmsgSensors?.phaseAB?.value ?
                (this.unitLmsgSensors?.phaseAB?.value + ' ' + this.unitLmsgSensors?.phaseAB?.units) :
                ''//this.$t('Not defined')
        },
        icon() {
            return this.showIcon ? 'sensors__battary_voltage' : false
        }
    },
}
</script>

<style scoped>

</style>